import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const insuredFinancialActivity: AnswerPathTreeNode = {
  path: 'insuredElectsAplProvisionsForWholeLifePlans',
  nodeId: NodeIds.insuredElectsAplProvisionsForWholeLifePlans,
};
